import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { AuthService } from '../../providers/auth/auth.service';
import {
  isModernLayoutTheme,
  LAYOUT_THEME_STORAGE_KEY,
  layoutThemeChanges$,
  normalizeLayoutTheme,
} from '../../providers/layout-theme/layout-theme';

@Component({
  selector: 'app-dashboard-switch',
  templateUrl: './dashboard-switch.component.html',
})
export class DashboardSwitchComponent implements OnDestroy, OnInit {
  useModernDashboard = false;
  private layoutThemeSubscription: Subscription;

  constructor(
    private auth: AuthService,
  ) {}

  ngOnInit() {
    this.updateDashboard();
    this.layoutThemeSubscription = layoutThemeChanges$.subscribe(theme => {
      this.useModernDashboard = this.shouldUseModernDashboard(theme);
    });
  }

  ngOnDestroy() {
    if (this.layoutThemeSubscription) {
      this.layoutThemeSubscription.unsubscribe();
    }
  }

  private updateDashboard() {
    const theme = normalizeLayoutTheme(localStorage.getItem(LAYOUT_THEME_STORAGE_KEY));

    this.useModernDashboard = this.shouldUseModernDashboard(theme);
  }

  private shouldUseModernDashboard(theme: string) {
    const user = this.auth.retrieveLocalUser();

    return !!user
      && user.account_type === 'teacher'
      && isModernLayoutTheme(theme);
  }
}
